import { UPDATE_NAME_SERVICE } from '../actions/name-service';

export const updateNameServiceReducer = (state = '', action) => {
  switch (action.type) {
    case UPDATE_NAME_SERVICE:
      return action.payload;
  }
  return state;
};
